/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DeviceCaseImage = {
    id?: string;
    createdAt?: string;
    updatedAt?: string;
    deviceCaseId?: string;
    objectKey?: string;
    type?: DeviceCaseImage.type;
};
export namespace DeviceCaseImage {
    export enum type {
        BODY = 'BODY',
        WITH_IMEI_OR_SN = 'WITH_IMEI_OR_SN',
        WITH_SETTINGS_SCREEN = 'WITH_SETTINGS_SCREEN',
    }
}

